<template lang="pug">
  .resources
    .row.m-bottom-2.space-between.bottom.m-top-5
      h3.title-medium {{ innerI18n.t('detailProgram.resources') }}
    .resources-grid.m-bottom-3
      resource-card.m-bottom-2(
        v-for='resource in resources'
        :key='resource.id'
        :resource='resource'
        noMargin
        :preferredLanguage='innerLocale'
      )
    .resources-grid.relative(v-if='loadingResources')
      sk-resource-card(v-for='n in 4' :key='n')
      .animation-container.row.middle.center.m-bottom-3.absolute(v-if='loadingResources')
        loader(size='inner')
    .row.center.width-100
      button.uppercase.text-small.blue(v-if='showLoadMoreResources' @click='loadMoreResources')
        | {{ innerI18n.t('detailProgram.showMore') }}
    .column.center.no-resource-container(v-if='isComingSoon')
      .background-cards
        .row.m-bottom-2
          sk-resource-card(v-for='n in 4' :key='n')
        .row
          sk-resource-card(v-for='n in 4' :key='n')
      .no-resource-info.relative
        lottie(:options='optionsNoResources' :style='comingSoonStyles')
        .column.center.absolute.width-100.top-position
          p.title-medium {{ innerI18n.t('detailProgram.workingOnEducationalProgram') }}
          p.title-medium.m-bottom-2 {{ innerI18n.t('detailProgram.comingSoon') }}
          span.dark-gray.text-big {{ innerI18n.t('detailProgram.interested') }}
          span.dark-gray.text-big.m-bottom-2 {{ innerI18n.t('detailProgram.earlyInformation') }}
          button.primary-button(type='button' @click='showElement({ element: "askForInformationModal" })')
            | {{ innerI18n.t('detailProgram.knowMore') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Loader from '../Loader'
import ResourceCard from '../ResourceCard'
import SkResourceCard from '../SkResourceCard'
import comingSoon from '@/assets/lottie/comingSoon.json'
import { innerI18n } from '../../main'
import { educationalProgramLanguageStatus } from '../../utils/constants'
import { comingSoonStyles } from '@/scss/lottie/program'

export default {
  components: {
    Loader,
    ResourceCard,
    SkResourceCard
  },
  data() {
    return {
      innerI18n,
      comingSoonStyles,
      nextPage: 0,
      optionsNoResources: { animationData: comingSoon }
    }
  },
  created() {
    this.loadMoreResources()
  },
  watch: {
    innerLocale() {
      this.nextPage = 0
      this.clearEducationalProgramResources()
      this.loadMoreResources()
    }
  },
  computed: {
    ...mapState({
      program: state => state.educationalProgram.educationalProgram,
      innerLocale: state => state.behavior.innerLocale,
      loadingResources: state => state.educationalProgram.educationalProgramResourcesLoading,
      resources: state => state.educationalProgram.educationalProgramResources
    }),
    isComingSoon() {
      return this.program.activatedLanguages[this.innerLocale] === educationalProgramLanguageStatus.comingSoon
    },
    showLoadMoreResources() {
      return this.resources.length < this.program.resourceTotalQuantity && !this.loadingResources
    }
  },
  methods: {
    ...mapActions([
      'showElement',
      'hydrateEducationalProgramResources'
    ]),
    loadMoreResources() {
      this.hydrateEducationalProgramResources({
        programId: this.$route.params.id,
        pageSize: 4,
        pageNumber: this.nextPage,
        locale: this.innerLocale
      })
      this.nextPage++
    }
  }
}

</script>

<style lang="scss" scoped>

.resources-grid{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 15px;
  width: 100%;
}

.background-cards {
  opacity: 0.5;
}

.animation-container {
  width: 100%;
  height: 290px;
  padding-right: 40px;
}

.top-position {
  top: 50%;
}

.no-resource-container {
  position: relative;
}

.no-resource-info {
  position: absolute;
  top: 10px;
}
</style>
